import React from 'react';
import { Link } from 'react-router-dom';

const LinkTree = () => {
    // Список ваших посилань (можна легко редагувати або отримувати з API)
    const links = [
        {
            id: 1,
            title: '✨ Каталог',
            url: 'https://www.instagram.com/lovestitch.ua', // Внутрішнє посилання через react-router-dom
            isExternal: false,
            isHighlighted: true, // Виділена кнопка (акцентна)
        },
        {
            id: 2,
            title: '📞 Зателефонувати',
            url: 'tel:+380987407162',
            isExternal: false,
            isHighlighted: false,
        },
        {
            id: 3,
            title: '📸 Наш Instagram',
            url: 'https://www.instagram.com/lovestitch.ua', // Замініть на ваш лінк
            isExternal: true,
            isHighlighted: false,
        },
        {
            id: 4,
            title: '🎵 Ми в TikTok',
            url: 'https://tiktok.com/@lovestitch.ua',
            isExternal: true,
            isHighlighted: false,
        },
        {
            id: 5,
            title: '💬 Зв’язатися в Telegram',
            url: 'https://t.me/+380987407162',
            isExternal: true,
            isHighlighted: false,
        },
    ];

    return (
        <div className="min-h-screen bg-[#faf8f5] flex flex-col items-center justify-between py-12 px-4 font-sans text-[#3d3a35]">

            {/* Основний контент */}
            <div className="max-w-md w-full flex flex-col items-center flex-grow justify-center">

                {/* Блок профілю */}
                <div className="flex flex-col items-center mb-8">
                    {/* Аватарка бренду */}
                    <div className="w-24 h-24 rounded-full bg-white border-2 border-[#d4a373] p-1 shadow-sm mb-4 flex items-center justify-center overflow-hidden">
                        {/* Замініть на реальний логотип: <img src="/logo.png" alt="Love Stitch" className="rounded-full object-cover" /> */}
                        {/*<span className="text-4xl">🪡</span>*/}
                        <img src="/logo.jpg" alt="Love Stitch" className="rounded-full object-cover" />
                    </div>

                    {/* Назва бренду */}
                    <h1 className="text-2xl font-bold tracking-tight mb-1">
                        Love Stitch UA
                    </h1>

                    {/* Посилання на домен/Нікнейм */}
                    <p className="text-sm font-medium text-[#d4a373] mb-3">
                        {/*www.lovestitchua.shop*/}
                        ВИШИВКА | БРЕНДУВАННЯ | ІНДИВІДУАЛЬНІ ЗАМОВЛЕННЯ
                    </p>

                    {/* Короткий опис / Біо */}
                    <p className="text-sm text-[#7a756e] text-center max-w-xs px-2 leading-relaxed">
                        Твій затишний простір стильного одягу та вишивки. Створено з любов'ю до кожного стібка. ✨
                    </p>
                </div>

                {/* Список посилань */}
                <div className="w-full space-y-4 mb-8">
                    {links.map((link) => {
                        const buttonClasses = link.isHighlighted
                            ? "w-full block py-4 px-6 bg-[#d4a373] text-white font-semibold rounded-xl shadow-md hover:bg-[#c39262] transition duration-300 transform hover:-translate-y-0.5 text-center text-base"
                            : "w-full block py-4 px-6 bg-white text-[#3d3a35] border border-[#e1dbd5] font-medium rounded-xl hover:border-[#d4a373] hover:bg-[#faf8f5] transition duration-300 transform hover:-translate-y-0.5 text-center text-base shadow-sm";

                        if (link.isExternal) {
                            return (
                                <a
                                    key={link.id}
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={buttonClasses}
                                >
                                    {link.title}
                                </a>
                            );
                        }

                        return (
                            <Link key={link.id} to={link.url} className={buttonClasses}>
                                {link.title}
                            </Link>
                        );
                    })}
                </div>

            </div>

            {/* Копірайт / Низ сторінки */}
            <div className="text-center mt-auto pt-4 border-t border-[#e6e2dd] w-full max-w-xs">
                <p className="text-xs text-[#9c968e] tracking-wide">
                    © {new Date().getFullYear()} lovestitchua.shop
                </p>
            </div>

        </div>
    );
};

export default LinkTree;